  $(document).ready(function(){
      $("#popupfoot").click(function(){
    	var check_cookie =  $.cookie('exam',1,true,{expire:60*1000});
          // alert(check_cookie);
       })
        if($.cookie('exam') ==null){
      $("#boxes").css("display","block");
          // $.cookie('exam',true,{expire:60*1000});
        }
   else{
      console.log("cookie SET");
     $("#boxes").css("display","none");
       }  
      });

/* display none search div style 3rd*/
  $(document).ready(function(){
  $(".home_style_3 .btn--link").click(function(){
    $('#SearchDrawer').css('display','none');
    });
});
/* End code display none search div style 3rd*/
/* display none search div style 4th*/
 $(document).ready(function(){
  $(".home_style_4 .btn--link").click(function(){
    $('#SearchDrawer').css('display','none');    
  });
});
/* End display none search div style 4th*/